// Copyright (c) 2020 WiseTime. All rights reserved.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file wisetime/user/type/timeline_status.proto (package wisetime.user.type, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file wisetime/user/type/timeline_status.proto.
 */
export const file_wisetime_user_type_timeline_status: GenFile = /*@__PURE__*/
  fileDesc("Cih3aXNldGltZS91c2VyL3R5cGUvdGltZWxpbmVfc3RhdHVzLnByb3RvEhJ3aXNldGltZS51c2VyLnR5cGUihwEKDlRpbWVsaW5lU3RhdHVzEg8KB3VzZXJfaWQYAiABKAkSNQoRbGFzdF9hcHBfYWN0aXZpdHkYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi0KCXJlYWRfdGltZRgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBCMwoaY29tLndpc2V0aW1lLmFwaS51c2VyLnR5cGVCE1RpbWVsaW5lU3RhdHVzUHJvdG9QAWIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * @generated from message wisetime.user.type.TimelineStatus
 */
export type TimelineStatus = Message<"wisetime.user.type.TimelineStatus"> & {
  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: google.protobuf.Timestamp last_app_activity = 3;
   */
  lastAppActivity?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp read_time = 4;
   */
  readTime?: Timestamp;
};

/**
 * Describes the message wisetime.user.type.TimelineStatus.
 * Use `create(TimelineStatusSchema)` to create a new message.
 */
export const TimelineStatusSchema: GenMessage<TimelineStatus> = /*@__PURE__*/
  messageDesc(file_wisetime_user_type_timeline_status, 0);

